module.exports = __webpack_public_path__ + "static/media/25.71860b80.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/25.png
// module id = 1131
// module chunks = 0